<template>
    <div class="admin-transform-recipe">
        <a href="#" style="margin-right: 10px; display: inline-block" class="btn btn-secondary btn-sm" @click.prevent="openDialog">Transférer</a>
        <el-dialog
            title="Changer utilisateur"
            :visible.sync="dialogue"
            width="30%">
            <p>Transférer les {{ recipes.length }} recettes à un autre utilisateur ?</p>
            <el-select
                v-model="selectedUser"
                placeholder="Select"
                filterable
                remote
                clearable
                :remote-method="search"
                :loading="loading"
            >
                <el-option
                    v-for="item in users"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">Annuler</el-button>
                <el-button type="primary" @click="submit">Valider</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "BulkRecipesChangeOwner",
    data() {
        return {
            dialogue: false,
            users: [],
            loading: false,
            recipesInput: [],
            selectedUser: null
        }
    },
    computed: {
        recipes(){
            var recipes = Array.from(this.recipesInput).map( v => v.value );
            return recipes
        }
    },
    methods: {
        openDialog(){
            this.recipesInput = $('input[name="recipes[]"]:checked')
            this.dialogue = true
        },
        search(query) {
            if (query !== '') {
                this.loading = true;
                axios.get('/pro/users', {params: {q: query, select: true}})
                    .then(response => {
                        this.users = response.data.data;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        submit() {
            this.$confirm('Confirmez-vous le changement de propriétaire ?', 'Attention', {
                confirmButtonText: 'Valider',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                axios.put('/pro/recipes/change-owner', {user_id: this.selectedUser, recipes: this.recipes})
                    .then(response => {
                        this.dialogue = false;
                        window.location.reload()
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }).catch(() => {
            });

        },
        close() {
            this.dialogue = false
        }
    }
}
</script>

<style scoped>

</style>
